import parent from './wgg.module';
import './wgg.run';
import './wgg.config';
import _ from 'lodash';

// Private variables
let unbindList = [];

export default class WggController{
    constructor($scope, $rootScope, $window, $q){
        "ngInject";
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$window = $window;
        this.$q = $q;
        this.init();
    }

    init(){
        this.$scope.$on("$destroy", this.onDestroy.bind(this));
    }

    getBindList(){
        return unbindList;
    }

    onDestroy(){
        _.forEach(unbindList, function(unbind, key){
            unbind();
        });
        unbindList = [];
    }

}

parent.controller('WggController', WggController);


// WEBPACK FOOTER //
// ./src/wgg/WggController.controller.js